@let clientEntity = (clientEntity$ | async);
@let werknemerEntity = (werknemerEntity$ | async);
@let loonstaatEntity = (loonstaatEntity$ | async);

@if (clientEntity && werknemerEntity && loonstaatEntity) {
  <snelstart-ui-details
    [config]="detailsConfig"
    [entityId]="id"
    [showTitleBorder]="false"
    title="{{ werknemerEntity?.werknemerGegevens?.persoon?.voorletters?.toUpperCase() }} {{ werknemerEntity?.werknemerGegevens?.persoon?.tussenvoegsel?.toUpperCase() }} {{ werknemerEntity?.werknemerGegevens?.persoon?.achternaam?.toUpperCase() }} "
  >

    @if (selectedTab === 1) {
      <snelstart-ui-details-header>
        <snelstart-ui-tab class="p-0">
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(1)"
            [isActive]="selectedPeriode === 1"
            id="tab01"
          >
            Januari
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(2)"
            [isActive]="selectedPeriode === 2"
            id="tab02"
          >
            Februari
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(3)"
            [isActive]="selectedPeriode === 3"
            id="tab03"
          >
            Maart
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(4)"
            [isActive]="selectedPeriode === 4"
            id="tab04"
          >
            April
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(5)"
            [isActive]="selectedPeriode === 5"
            id="tab05"
          >
            Mei
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(6)"
            [isActive]="selectedPeriode === 6"
            id="tab06"
          >
            Juni
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(7)"
            [isActive]="selectedPeriode === 7"
            id="tab07"
          >
            Juli
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(8)"
            [isActive]="selectedPeriode === 8"
            id="tab08"
          >
            Augustus
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(9)"
            [isActive]="selectedPeriode === 9"
            id="tab09"
          >
            September
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(10)"
            [isActive]="selectedPeriode === 10"
            id="tab10"
          >
            Oktober
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(11)"
            [isActive]="selectedPeriode === 11"
            id="tab11"
          >
            November
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectPeriode(12)"
            [isActive]="selectedPeriode === 12"
            id="tab12"
          >
            December
          </snelstart-ui-tab-item>
        </snelstart-ui-tab>
      </snelstart-ui-details-header>
    }

    @if (selectedTab === 2) {
      <snelstart-ui-details-header>
        <snelstart-ui-tab class="p-0">
          <snelstart-ui-tab-item
            (click)="onSelectTabDv(0)"
            [isActive]="selectedTabDv === 0"
            id="tabDv0"
          >
            Vaste vergoedingen
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectTabDv(1)"
            [isActive]="selectedTabDv === 1"
            id="tabDv0"
          >
            Dienstverband
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectTabDv(2)"
            [isActive]="selectedTabDv === 2"
            id="tabDv1"
          >
            Contract
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectTabDv(3)"
            [isActive]="selectedTabDv === 3"
            id="tabDv2"
          >
            Werkrooster
          </snelstart-ui-tab-item>
          <snelstart-ui-tab-item
            (click)="onSelectTabDv(4)"
            [isActive]="selectedTabDv === 4"
            id="tabDv3"
          >
            Fiscaal
          </snelstart-ui-tab-item>

          <snelstart-ui-tab-content>
            @if (selectedTabDv === 0) {
              <snelstart-venture-fiscaal-vastevergoeding [id]="id"
                                                         [selectedTabDv]="selectedTabDv"></snelstart-venture-fiscaal-vastevergoeding>
            }
            @if (selectedTabDv === 1) {
              <snelstart-venture-fiscaal-dienstverband [id]="id"
                                                       [selectedTabDv]="selectedTabDv"></snelstart-venture-fiscaal-dienstverband>
            }
            @if (selectedTabDv === 2) {
              <snelstart-venture-fiscaal-contract [id]="id"
                                                  [selectedTabDv]="selectedTabDv"></snelstart-venture-fiscaal-contract>
            }
            @if (selectedTabDv === 3) {
              <snelstart-venture-fiscaal-rooster [id]="id"
                                                 [selectedTabDv]="selectedTabDv"></snelstart-venture-fiscaal-rooster>
            }
            @if (selectedTabDv === 4) {
              <snelstart-venture-fiscaal-fiscaal [id]="id"
                                                 [selectedTabDv]="selectedTabDv"></snelstart-venture-fiscaal-fiscaal>
            }
          </snelstart-ui-tab-content>

        </snelstart-ui-tab>
      </snelstart-ui-details-header>
    }

    @if (selectedTab === 1) {
      <snelstart-ui-details-content>
        <snelstart-venture-fiscaal-salarisstrook [id]="id"></snelstart-venture-fiscaal-salarisstrook>
      </snelstart-ui-details-content>
    }

    <snelstart-ui-details-buttons>
      <snelstart-ui-button [config]="saveButtonConfig"
                           [disabled]="werknemerEntity?.werknemerGegevens === undefined && loonstaatEntity?.loonStaat === undefined"
                           type="primary">
        Opslaan
      </snelstart-ui-button>
      @if (selectedTab === 1) {
        <snelstart-ui-button [config]="configSettings(2)" class="me-1"
                             icon="gear"
                             type="secondary">
          Dienstverband
        </snelstart-ui-button>
      }
      @if (selectedTab === 2) {
        <snelstart-ui-button [config]="configSettings(1)" class="me-1"
                             icon="coins"
                             type="secondary">
          Verloningen
        </snelstart-ui-button>
      }
      @if (selectedTab !== 2) {
        <snelstart-ui-button (click)="showDialogSalSpec()"
                             [disabled]="werknemerEntity?.werknemerGegevens === undefined && loonstaatEntity?.loonStaat === undefined"
                             class="me-1" icon="file-pdf" id="print" type="secondary">
          Salarisspecificatie
        </snelstart-ui-button>
      }
    </snelstart-ui-details-buttons>

    <!-- Legacy toelichting dialog intentionally removed. -->

    <snelstart-ui-dialog-definition [(visible)]="dialogSalSpecVisible" id="dialogSalSpecVisible"
                                    size="md"
                                    title="Rapportage salarisspecificatie">
      <snelstart-ui-dialog-body>

        <div class="pt-2">
          <form [formGroup]="afdrukkenForm">
            <snelstart-ui-switch-form-control
              [label]="afdrukkenForm.get('conceptWatermerk')?.value ? 'Watermerk (Concept)' : 'Geen watermerk'"
              formControlName="conceptWatermerk"
              id="switch"
              name="switch">
            </snelstart-ui-switch-form-control>
          </form>
        </div>



      </snelstart-ui-dialog-body>

      <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x icon="check" id="sluiten" type="secondary" class="me-1">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button (click)="onGeneratePdfClick()"
                             [disabled]="werknemerEntity?.werknemerGegevens === undefined && loonstaatEntity?.loonStaat === undefined"
                             class="me-1" icon="file-pdf" id="print" type="primary">
          Genereren rapport
        </snelstart-ui-button>
      </snelstart-ui-dialog-buttons>
    </snelstart-ui-dialog-definition>
  </snelstart-ui-details>
}
